import * as z from "zod";

export const validationSchema = z.object({
  hour: z.number().int().min(0).max(23),
  minute: z.number().int().min(0).max(59),
  second: z.number().int().min(0).max(59),
  nano: z.number().int().nonnegative(),
});

export const TimeZoneValidationSchema = validationSchema;
export type TimeZoneFormInput = z.infer<typeof TimeZoneValidationSchema>;
